
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row mt-2">
    <div class="col-12">
      <error [error]="error"></error>
    </div>
    <div class="col-12">
      <success #success></success>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter contract details:</p>
      </div>
    </div>
    <div class="col">
      <div class="float-right">
        <button class="btn btn-primary" [disabled]="isLocked || contract.locked" type="button" (click)="upload()">Upload to K2</button>
      </div>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-md-10 card-block">
      <form #contractForm="ngForm">
        <fieldset [disabled]="isLocked || contract.locked">
          <div class="row">
            <div class="col">
              <ul>
                <li>You cannot modify any contract that already exists in K2.</li>
                <li>Changes to this form will not be saved when you leave this page unless the contract is sent to K2.</li>
              </ul>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="msContractId">MS Contract ID:</label>
              <input class="form-control" id="msContractId" type="text" [(ngModel)]="contract.msContractId" name="msContractId" maxlength="70" required>
            </div>
            <div class="form-group col-lg-6">
              <label class="required" for="msMasterContract">Master Contract ID:</label>
              <input class="form-control" id="msMasterContract" type="text" [(ngModel)]="contract.msMasterContract" name="msMasterContract" maxlength="70" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required">Contract Type:</label>
              <select class="form-control" [(ngModel)]="contract.contractType" name="contractType" required>
                <option value="DMPS">DMPS</option>
                <option value="PMPS">PMPS</option>
              </select>
            </div>
            <div class="form-group col-lg-6" [hidden]="contract.contractType!=&quot;PMPS&quot;">
              <label class="required" for="partnerProId">Partner:</label>
              <select class="form-control" id="partnerProId" [(ngModel)]="contract.partnerProId" name="partnerProId" maxlength="50">
                <option value=""></option>
                <option *ngFor="let partner of contract.partnersList" [value]="partner.id">{{ partner.name }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <div class="form-check col-lg-6">
                  <input class="form-check-input" id="ttc" type="checkbox" [(ngModel)]="contract.ttc" name="ttc">
                  <label class="form-check-label" for="ttc">Trust the Customer (TTC)</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <div class="inline-block">
                <label class="required" for="contractStartDate">Contract Start Date:</label>
              </div>
              <div class="input-group">
                <input class="form-control" id="contractStartDate" [(ngModel)]="contract.ttcStartDate" name="contractStartDate" type="text" required>
                <datepicker class="right input-group-append" [(ngModel)]="contract.ttcStartDate" name="contractStartDateSelector" required></datepicker>
              </div>
            </div>
            <div class="form-group col-lg-6">
              <div class="inline-block">
                <label class="required" for="contractEndDate">Contract End Date:</label>
              </div>
              <div class="input-group">
                <input class="form-control" id="contractEndDate" [(ngModel)]="contract.ttcEndDate" name="contractEndDate" type="text" required>
                <datepicker class="right input-group-append" [(ngModel)]="contract.ttcEndDate" name="contractEndDateSelector" required></datepicker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-12">
              <label class="required">Customer Name Shipping Label:</label>
              <input class="form-control" id="customerNameShipLabl" type="text" [(ngModel)]="contract.customerNameShipLabl" name="customerNameShipLabl" maxlength="60" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label>Service Partner ID:</label>
              <input class="form-control" id="servicePartner" type="text" [(ngModel)]="contract.servicePartner" name="servicePartner" maxlength="70" required>
            </div>
            <div class="form-group col-lg-6">
              <label>Solution Said Number:</label>
              <input class="form-control" id="solutionSaidNR" type="text" [(ngModel)]="contract.solutionSaidNR" name="solutionSaidNR" maxlength="160" required>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-12">
              <label for="comments1">Comment 1:</label>
              <input class="form-control" id="comments1" type="text" [(ngModel)]="contract.comments1" name="comments1" maxlength="3000">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-12">
              <label for="comments2">Comment 2:</label>
              <input class="form-control" id="comments2" type="text" [(ngModel)]="contract.comments2" name="comments2" maxlength="3000">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-12">
              <label for="comments3">Comment 3:</label>
              <input class="form-control" id="comments3" type="text" [(ngModel)]="contract.comments3" name="comments3" maxlength="3000">
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-12">
              <label for="comments4">Comment 4:</label>
              <input class="form-control" id="comments4" type="text" [(ngModel)]="contract.comments4" name="comments4" maxlength="3000">
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</div>